let product_json;
let price_str;
let price_json;
let inventory_str;
let inventory_json;
let product_type;
const style_numbers_json = {};
const variantClearanceValues = {};

const processProductData = () => {
  const productJsonElement = document.querySelector('[data-product-json]');
  if (!productJsonElement) {
    return;
  }

  try {
    product_json = JSON.parse(productJsonElement.innerHTML);
    product_type = product_json.type;

    const inventoryElement = document.querySelector('[data-inventory-json]');
    inventory_str = decodeURIComponent(inventoryElement.getAttribute('data-inventory-json'));
    inventory_json = JSON.parse(inventory_str);

    const priceElement = document.querySelector('[data-price-json]');
    price_str = decodeURIComponent(priceElement.getAttribute('data-price-json'));
    price_json = JSON.parse(price_str);

    product_json.variants.forEach((variant) => {
      if (!style_numbers_json[variant.option1]) {
        style_numbers_json[variant.option1] = variant.barcode;
      }
    });

    product_json.variants.forEach((variant) => {
      const cents = String(variant.price).slice(-2);
      variantClearanceValues[variant.id] = cents === '97';
    });
  } catch (err) {
    console.log('err:', err);
  }
};

document.addEventListener('shouldProcessProductData', () => {
  processProductData();
});

export const getProductJson = () => {
  return product_json;
};
export const getProductType = () => {
  return product_type;
};
export const getProductPrices = () => {
  return price_json;
};
export const getProductInventories = () => {
  return inventory_json;
};
export const getProductClearances = () => {
  return variantClearanceValues;
};
export const getProductStyleNumbers = () => {
  return style_numbers_json;
};
